// removed by extract-text-webpack-plugin
module.exports = {"xl":"_2fjGD","l":"_144GS","page":"_3EkAU","m":"_-H_JB","text":"bako_","text-narrow":"_3H2aO","s":"_1XxUy"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/styleTools/SizeClasses.scss
 ** module id = 122
 ** module chunks = 0
 **/